import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  getStartedGreetingMessage: {
    id: "hosted-application: explainer screen heading",
    defaultMessage: "Hi{firstName}, welcome to Wayflyer!",
  },
  getStartedDescription: {
    id: "hosted-application: explainer screen body text",
    defaultMessage: "We’ve partnered with {partnerName} to help you grow.",
  },
  getStartedButton: {
    id: "hosted-application: explainer screen button",
    defaultMessage: "Get started",
  },
  getStartedAlreadyHaveAnAccount: {
    id: "hosted-application: explainer screen text to ask user to login in case if it has an account",
    defaultMessage: "Already have an account?",
  },
  getStartedNavigateToLogInPageLink: {
    id: "hosted-application: explainer screen link that redirects user to Log in page",
    defaultMessage: "Log in",
  },
  descriptionCardsHeading: {
    id: "hosted-application: description cards heading",
    defaultMessage: "How it works",
  },
  descriptionCardsFirstCardSubheading: {
    id: "hosted-application: description cards first card subheading",
    defaultMessage: "Step 1",
  },
  descriptionCardsFirstCardHeading: {
    id: "hosted-application: description cards first card heading",
    defaultMessage: "Setup and connect",
  },
  descriptionCardsFirstCardBody: {
    id: "hosted-application: description cards first card body",
    defaultMessage: "Create your account, share basic information, and connect the platforms you use daily.",
  },
  descriptionCardsSecondCardSubheading: {
    id: "hosted-application: description cards second card subheading",
    defaultMessage: "Step 2",
  },
  descriptionCardsSecondCardHeading: {
    id: "hosted-application: description cards second card heading",
    defaultMessage: "Review tailored offers",
  },
  descriptionCardsSecondCardBody: {
    id: "hosted-application: description cards second card body",
    defaultMessage: "Our technology analyzes your data to create personalized funding offers.",
  },
  descriptionCardsThirdCardSubheading: {
    id: "hosted-application: description cards third card subheading",
    defaultMessage: "Step 3",
  },
  descriptionCardsThirdCardHeading: {
    id: "hosted-application: description cards third card heading",
    defaultMessage: "Receive funds in hours",
  },
  descriptionCardsThirdCardBody: {
    id: "hosted-application: description cards third card body",
    defaultMessage: "Once you accept an offer, funds will hit your account in as little as 24 hours.",
  },
});
